import { render, staticRenderFns } from "./TraySvg.vue?vue&type=template&id=4cee1228"
import script from "./TraySvg.vue?vue&type=script&lang=js"
export * from "./TraySvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports